import React, { Component, Fragment } from "react";
import { detect } from "detect-browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import logo from "./img/logo.png";
import headerData from "./data/header-data";
import {
  Wrapper,
  Inner,
  LogoLink,
  Logo,
  Links,
  Left,
  Right,
  Link,
  ButtonLink,
  MobileMenu,
  MobileMenuTrigger,
  MobileMenuContent,
  MobileLinks,
  MobileLink,
  MobileButtonLink,
} from "./styles/header-styles";

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileMenuActive: false,
    };
  }

  toggleMobileMenu = () => {
    const { mobileMenuActive } = this.state;

    this.setState({
      mobileMenuActive: !mobileMenuActive,
    });
  };

  render() {
    const { mobileMenuActive } = this.state;
    const isIe = detect().name === "ie";

    return (
      <Fragment>
        <MobileMenuTrigger onClick={this.toggleMobileMenu}>
          {mobileMenuActive ? (
            <FontAwesomeIcon icon={faTimes} />
          ) : (
            <FontAwesomeIcon icon={faBars} />
          )}
        </MobileMenuTrigger>
        <MobileMenu id="mobile-menu">
          <MobileMenuContent active={mobileMenuActive}>
            <MobileLinks>
              <MobileLink
                href={headerData.left.link1.url}
                title={headerData.left.link1.label}
              >
                {headerData.left.link1.label}
              </MobileLink>
              <MobileLink
                href={headerData.left.link2.url}
                title={headerData.left.link2.label}
              >
                {headerData.left.link2.label}
              </MobileLink>
              <MobileLink
                href={headerData.right.link1.url}
                title={headerData.right.link1.label}
              >
                {headerData.right.link1.label}
              </MobileLink>
              <MobileLink
                href={headerData.right.link2.url}
                title={headerData.right.link2.label}
              >
                {headerData.right.link2.label}
              </MobileLink>
              <MobileLink
                href={headerData.right.link3.url}
                title={headerData.right.link3.label}
              >
                {headerData.right.link3.label}
              </MobileLink>
              <MobileLink
                href={headerData.right.link4.url}
                title={headerData.right.link4.label}
              >
                {headerData.right.link4.label}
              </MobileLink>
              <MobileButtonLink
                href={headerData.right.link5.url}
                title={headerData.right.link5.label}
              >
                {headerData.right.link5.label}
              </MobileButtonLink>
            </MobileLinks>
          </MobileMenuContent>
        </MobileMenu>
        <Wrapper
          active={mobileMenuActive}
          className="fadeInDown animated"
          data-test-id="header"
        >
          <Inner isIe={isIe}>
            <LogoLink href={headerData.brandLink} title="Hiring Hub">
              <Logo src={logo} alt="Logo" />
            </LogoLink>
            <Links>
              <Left>
                <Link
                  href={headerData.left.link1.url}
                  title={headerData.left.link1.label}
                >
                  {headerData.left.link1.label}
                </Link>
                <Link
                  href={headerData.left.link2.url}
                  title={headerData.left.link2.label}
                >
                  {headerData.left.link2.label}
                </Link>
              </Left>
              <Right>
                <Link
                  href={headerData.right.link1.url}
                  title={headerData.right.link1.label}
                >
                  {headerData.right.link1.label}
                </Link>
                <Link
                  href={headerData.right.link2.url}
                  title={headerData.right.link2.label}
                >
                  {headerData.right.link2.label}
                </Link>
                <Link
                  href={headerData.right.link3.url}
                  title={headerData.right.link3.label}
                >
                  {headerData.right.link3.label}
                </Link>
                <Link
                  href={headerData.right.link4.url}
                  title={headerData.right.link4.label}
                >
                  {headerData.right.link4.label}
                </Link>
                <ButtonLink
                  href={headerData.right.link5.url}
                  title={headerData.right.link5.label}
                >
                  {headerData.right.link5.label}
                </ButtonLink>
              </Right>
            </Links>
          </Inner>
        </Wrapper>
      </Fragment>
    );
  }
}

export default Header;
